import { Link, LinkProps } from "react-router-dom";

interface Item extends LinkProps {
  icon: React.ReactNode;
  label: string;
}

interface Props {
  items: Item[];
}

export const NavList: React.FC<Props> = ({ items }) => {
  return (
    <div className="nav-list h4">
      {items.map(({ icon, label, ...rest }, index) => (
        <Link key={index} {...rest}>
          <span>{icon}</span>
          {label}
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M5.4435 15.5481L11.3361 9.99254L5.4435 4.43701C5.30289 4.30445 5.19136 4.14708 5.11526 3.97388C5.03917 3.80068 5 3.61504 5 3.42757C5 3.2401 5.03917 3.05446 5.11526 2.88126C5.19136 2.70806 5.30289 2.55069 5.4435 2.41813C5.5841 2.28556 5.75102 2.18041 5.93473 2.10867C6.11844 2.03693 6.31534 2 6.51419 2C6.71303 2 6.90993 2.03693 7.09364 2.10867C7.27735 2.18041 7.44428 2.28556 7.58488 2.41813L14.5558 8.99025C15.1481 9.54867 15.1481 10.4507 14.5558 11.0091L7.58488 17.5813C7.44438 17.714 7.27749 17.8193 7.09377 17.8912C6.91004 17.963 6.71309 18 6.51419 18C6.31529 18 6.11833 17.963 5.93461 17.8912C5.75089 17.8193 5.584 17.714 5.4435 17.5813C4.86638 17.0229 4.8512 16.1065 5.4435 15.5481Z" />
          </svg>
        </Link>
      ))}
    </div>
  );
};
